export class Stavka{

    constructor() {}

    RacunZaduzenja: string = null;
    NazivZaduzenja: string = null;
    MestoZaduzenja: string = null;
    IzvorInformacije: string = null;
    ModelPozivaZaduzenja: string = null;
    PozivZaduzenja: string = null;
    SifraPlacanja: string = null;
    Iznos: number = null;   
    RacunOdobrenja: string = null;
    NazivOdobrenja: string = null;
    MestoOdobrenja: string = null;
    ModelPozivaOdobrenja: string = null;
    PozivOdobrenja: string = null;
    SvrhaDoznake: string = null;
    PodatakZaReklamaciju: string = null;
    DatumValute: string = null;
    NacinObracuna: string = null;
    PrioritetNaloga: string = null;
    VremeUnosa: string = null;
    VremeIzvrsenja: string = null;
    StatusNaloga: string = null;
    TipSloga: string = null;

    Deserialize(input:any){
        this.RacunZaduzenja=input.RacunZaduzenja._text;
        this.NazivZaduzenja = input.NazivZaduzenja._text;
        this.MestoZaduzenja = input.MestoZaduzenja._text;
        this.IzvorInformacije = input.IzvorInformacije._text;
        this.ModelPozivaZaduzenja = input.ModelPozivaZaduzenja._text;
        this.PozivZaduzenja = input.PozivZaduzenja._text;
        this.SifraPlacanja = input.SifraPlacanja._text;
        this.Iznos = parseFloat(input.Iznos._text.split(',').join('.'));       
        this.RacunOdobrenja = input.RacunOdobrenja._text;
        this.NazivOdobrenja = input.NazivOdobrenja._text;
        this.MestoOdobrenja = input.MestoOdobrenja._text;
        this.ModelPozivaOdobrenja = input.ModelPozivaOdobrenja._text;
        this.PozivOdobrenja = input.PozivOdobrenja._text;
        this.SvrhaDoznake = input.SvrhaDoznake._text;
        this.PodatakZaReklamaciju = input.PodatakZaReklamaciju._text;
        this.DatumValute = input.DatumValute._text;
        this.NacinObracuna = input.NacinObracuna == undefined ? '' : input.NacinObracuna._text;
        this.PrioritetNaloga = input.PrioritetNaloga == undefined ? '' : input.PrioritetNaloga._text;
        this.VremeUnosa = input.VremeUnosa._text;
        this.VremeIzvrsenja = input.VremeIzvrsenja._text;
        this.StatusNaloga = input.StatusNaloga._text;
        this.TipSloga = input.TipSloga._text;
        return this;
    }

}